import connection from './config'

export const getWxShareInfo = (params) => {
  return connection.request({
    url: `/api/wechat/menu/config?url=${params.url}`,
    method: 'get'
  })
}
